export default __webpack_public_path__ + "static/media/woman.522deb48.png";